module.exports = __webpack_public_path__ + "static/media/brasil.4c3e7738.webp";